<template>
    <div class="short-video-list">
        <short-video-list-skeleton v-if="pageLoading" style="margin-bottom: 100vh"></short-video-list-skeleton>
        <div class="medical-column-detail-list" v-if="!pageLoading && list !== null && list && list.length">
            <van-list v-if="list" v-model="loading" :finished="finished" finished-text="已到底部" :immediate-check="false" @load="onLoad">
                <van-row class="short-video-list-section">
                    <div class="short-video-list-box" v-for="item in list" :key="item.id" @click="goDetail(item)">
                        <div class="short-video-list-box-img">
                            <van-image fit="cover" :src="item.cover_img" style="width: 100%;height: 100%;border-radius: 6px;" />
                            <img v-if="item.meeting_status == 0" class="img-type" src="/static/img/live/icon_list_tag_live_count_down.svg" alt="" />
                            <img v-if="item.meeting_status == 1" class="img-type" src="/static/img/live/icon_list_tag_academic_process.svg" alt="" />
                            <img v-if="item.meeting_status == 2" class="img-type" src="/static/img/live/icon_list_tag_academic_end.svg" alt="" />
                        </div>
                        <div class="short-video-list-box-title">{{ item.title }}</div>
                        <span v-if="item.meeting_status !== 2 && item.origin_type === 14">
                            <span class="enrollment" v-if="!item.isApply" @click.stop="goEnrollment(item)">报名参会</span>
                            <span class="registered" v-else>已报名</span>
                        </span>
                        <div class="short-video-list-box-author" v-if="item.origin_type === 4">
                            <span v-if="item.type == 2">
                                 共{{ item.total_count }}期 {{ item.view_count }}人观看
                            </span>
                            <span v-else>
                                {{ item.view_count }}人观看
                            </span>
                        </div>
                    </div>
                </van-row>
            </van-list>
        </div>
    </div>
</template>
<script>
import Interface from '@/util/interface'
import shortVideoListSkeleton from '@/skeleton/shortVideoListSkeleton'
export default {
    name: 'live-column-list',
    components: {
        'short-video-list-skeleton': shortVideoListSkeleton
    },
    data() {
        return {
            value: '',
            active: '',
            category_id: 0,
            loading: true,
            finished: false,
            category_child_id: 0,
            banners: [],
            categories: [],
            categories_child: [],
            recommend: [],
            list: [],
            pageLoading: true,
            ListPage: {
                page: 1,
                pageSize: 10
            }
        }
    },

    methods: {
        onLoad() {
            this.finished = false
            this.loading = true
            this.ListPage.page++
            this.fetch('column_list')
        },
        goDetail(item) {
            if (item.origin_type === 4) {
                Interface.goLiveDetail(this, { id: item.origin_id, type: item.type, live_status: item.live_status })
            } else if (item.origin_type === 14 || item.origin_type === 31) {
                Interface.goMeeting(this, {
                    is_saas: item.is_saas,
                    type: item.type,
                    uuid: item.uuid
                })
            } else if (item.origin_type === 13) {
                Interface.goTopic(this, {
                    id: item.origin_id
                })
            }
        },
        goEnrollment(item) {
            Interface.goMeeting(this, {
                is_saas: item.is_saas,
                type: item.type,
                uuid: item.uuid
            })
            // Interface.goLiveDetail(this, row)
        },
        fetch(scene) {
            if (scene === 'column_list') {
                //  Interface.live.column.list
                Interface.getData('get', '/live/api/academic/content', this.ListPage).then(res => {
                    if (res.data.list === null) {
                        this.finished = true
                        return
                    }

                    this.list = [...this.list, ...res.data.list]
                    this.loading = false

                    if (res.data.page >= res.data.total_page) {
                        this.finished = true
                    }

                    setTimeout(() => {
                        this.pageLoading = false
                    }, 500)
                })
            }
        }
    },
    created() {
        if (!this.finished) {
            this.fetch('column_list')
        }
        Interface.getShareInfo(this, '直播专栏', '', '',4)
        let source_type = Interface.getUrl(window.location.href)
        if (source_type) {
            Interface.mFootPrint(0, 4,0, 0, source_type, '')
        }
    }
}
</script>
<style lang="scss">
@import './index.scss';
</style>



// WEBPACK FOOTER //
// src/views/live/column_list/index.vue